export const kakaoEmoji = {
  emojiSet: [
    {
      name: '하트뿅',
      position: '-5px -90px'
    },
    {
      name: '하하',
      position: '-90px -90px'
    },
    {
      name: '우와',
      position: '-175px -90px'
    },
    {
      name: '심각',
      position: '-260px -90px'
    },
    {
      name: '힘듦',
      position: '-345px -90px'
    },
    {
      name: '흑흑',
      position: '-430px -90px'
    },
    {
      name: '아잉',
      position: '-515px -90px'
    },
    {
      name: '찡긋',
      position: '-600px -90px'
    },
    {
      name: '뿌듯',
      position: '-685px -90px'
    },
    {
      name: '깜짝',
      position: '-770px -90px'
    },
    {
      name: '빠직',
      position: '-855px -90px'
    },
    {
      name: '짜증',
      position: '-940px -90px'
    },
    {
      name: '제발',
      position: '-5px -175px'
    },
    {
      name: '씨익',
      position: '-90px -175px'
    },
    {
      name: '신나',
      position: '-175px -175px'
    },
    {
      name: '헉',
      position: '-260px -175px'
    },
    {
      name: '열받아',
      position: '-345px -175px'
    },
    {
      name: '흥',
      position: '-430px -175px'
    },
    {
      name: '감동',
      position: '-515px -175px'
    },
    {
      name: '뽀뽀',
      position: '-600px -175px'
    },
    {
      name: '멘붕',
      position: '-685px -175px'
    },
    {
      name: '정색',
      position: '-770px -175px'
    },
    {
      name: '쑥스',
      position: '-855px -175px'
    },
    {
      name: '꺄아',
      position: '-940px -175px'
    },
    {
      name: '좋아',
      position: '-5px -260px'
    },
    {
      name: '굿',
      position: '-90px -260px'
    },
    {
      name: '훌쩍',
      position: '-175px -260px'
    },
    {
      name: '허걱',
      position: '-260px -260px'
    },
    {
      name: '부르르',
      position: '-345px -260px'
    },
    {
      name: '푸하하',
      position: '-430px -260px'
    },
    {
      name: '발그레',
      position: '-515px -260px'
    },
    {
      name: '수줍',
      position: '-600px -260px'
    },
    {
      name: '컴온',
      position: '-685px -260px'
    },
    {
      name: '졸려',
      position: '-770px -260px'
    },
    {
      name: '하트',
      position: '-855px -260px'
    },
    {
      name: '실연',
      position: '-940px -260px'
    },
    {
      name: '별',
      position: '-5px -345px'
    },
    {
      name: '브이',
      position: '-90px -345px'
    },
    {
      name: '오케이',
      position: '-175px -345px'
    },
    {
      name: '최고',
      position: '-260px -345px'
    },
    {
      name: '최악',
      position: '-345px -345px'
    },
    {
      name: '그만',
      position: '-430px -345px'
    },
    {
      name: '땀',
      position: '-515px -345px'
    },
    {
      name: '알약',
      position: '-600px -345px'
    },
    {
      name: '밥',
      position: '-685px -345px'
    },
    {
      name: '커피',
      position: '-770px -345px'
    },
    {
      name: '맥주',
      position: '-855px -345px'
    },
    {
      name: '와인',
      position: '-940px -345px'
    },
    {
      name: '치킨',
      position: '-5px -430px'
    },
    {
      name: '축하',
      position: '-90px -430px'
    },
    {
      name: '음표',
      position: '-175px -430px'
    },
    {
      name: '선물',
      position: '-260px -430px'
    },
    {
      name: '케익',
      position: '-345px -430px'
    },
    {
      name: '촛불',
      position: '-430px -430px'
    },
    {
      name: '컵케익a',
      position: '-515px -430px'
    },
    {
      name: '컵케익b',
      position: '-600px -430px'
    },
    {
      name: '해',
      position: '-685px -430px'
    },
    {
      name: '구름',
      position: '-770px -430px'
    },
    {
      name: '비',
      position: '-855px -430px'
    },
    {
      name: '눈',
      position: '-940px -430px'
    },
    {
      name: '똥',
      position: '-5px -515px'
    },
    {
      name: '근조',
      position: '-90px -515px'
    },
    {
      name: '딸기',
      position: '-175px -515px'
    },
    {
      name: '호박',
      position: '-260px -515px'
    },
    {
      name: '입술',
      position: '-345px -515px'
    },
    {
      name: '야옹',
      position: '-430px -515px'
    },
    {
      name: '돈',
      position: '-515px -515px'
    },
    {
      name: '담배',
      position: '-600px -515px'
    },
    {
      name: '축구',
      position: '-685px -515px'
    },
    {
      name: '야구',
      position: '-770px -515px'
    },
    {
      name: '농구',
      position: '-855px -515px'
    },
    {
      name: '당구',
      position: '-940px -515px'
    },
    {
      name: '골프',
      position: '-5px -600px'
    },
    {
      name: '카톡',
      position: '-90px -600px'
    },
    {
      name: '꽃',
      position: '-175px -600px'
    },
    {
      name: '총',
      position: '-260px -600px'
    },
    {
      name: '크리스마스',
      position: '-345px -600px'
    },
    {
      name: '콜',
      position: '-430px -600px'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/operation/fragments/chat_area/kakao_emoji.js